import type { MouseEvent, HTMLProps } from 'react';

/**
 * This is the type definition of the `onNavigate` function that is
 * passed into the `Hotsauce.Provider`. It is a shared type with the legacy
 * package and is redefined to avoid importing the definition from the legacy
 * package and creating a dependency on that package.
 *
 * Other type definition:
 * - `packages/legacy/src/webapp/utils/routing/on-navigate.ts`
 */
export interface OnNavigateProps {
  event: MouseEvent<HTMLAnchorElement>;
  href: string;
  [key: string]: unknown;
}

interface NavigationHandlerProps {
  event: MouseEvent<HTMLAnchorElement>;
  isExternal: boolean;
  linkProps: HTMLProps<HTMLAnchorElement>;
  onNavigate: (props: OnNavigateProps) => void | undefined;
}

/**
 * Helper function to call provided navigationOverrideHandler from `Link` and `Button[as="a"]` components.
 */
export const navigationClickHandler = ({
  event,
  isExternal,
  linkProps,
  onNavigate,
}: NavigationHandlerProps): void => {
  /**
   * If an`onClick` function was attached to the`Link` or`Button` call this first so any tracking / event handling
   * is done before we pass the event on to any navigation handler.
   */
  if (linkProps.onClick) {
    linkProps.onClick(event);
  }

  // If the previous handler called `preventDefault` or this is an external link we don't need to call the handler.
  if (!event.defaultPrevented && !isExternal && onNavigate) {
    onNavigate({
      event: event,
      href: linkProps.href,
      ...linkProps,
    });
  }
};
